export default __webpack_public_path__ + "static/media/ordist-logo.min.28ac09fd.svg";